





























































import { mapGetters } from 'vuex';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { BulletinCommentEntity } from '@/entities/bulletin-comment.entity';
import BulletinReactionItem from '@/components/ViewComponent/Bulletin/Reaction/BulletinReactionItem.vue';
import BulletinReactionButtonAdd from '@/components/ViewComponent/Bulletin/Reaction/BulletinReactionButtonAdd.vue';
import { UseService } from '@/services/service';
import BulletinCommentReactionService from '@/services/bulletin-comment-reaction.service';
import EditBulletinComment from '@/components/ViewComponent/Bulletin/BulletinComment/EditBulletinComment.vue';
import { StaffEntity } from '@/entities/staff.entity';
import { saveAs } from 'file-saver';
import UserAvatar from '@/components/Helper/UserAvatar.vue';

@Component<BulletinCommentItem>({
  components: {
    UserAvatar,
    EditBulletinComment,
    BulletinReactionButtonAdd,
    BulletinReactionItem,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class BulletinCommentItem extends Vue {
  currentStaff!: StaffEntity;

  isShow = false;

  showModal() {
    if (this.currentStaff.id !== this.comment.staffId) return;
    this.isShow = true;
  }

  @Prop({ type: Object as PropType<BulletinCommentEntity> })
  comment: BulletinCommentEntity;

  @UseService(BulletinCommentReactionService)
  service: BulletinCommentReactionService;

  download = saveAs;
}
